import React from "react";
import UniversalButton from "components/uiComponents/UniversalButton";
import "./LoaderWindow.scss";
import { useHistory } from "react-router-dom";

const LoaderWindow = () => {
  const history = useHistory()
  const handleCancel = () => {
    history.push('/')
  };

  return (
    <div className={"loader-window-wrapper"}>
        <div className={"loader-window"}>
          <div className={"loader-window_info"}>
            <h2>Running test</h2>
            <span>Checking...</span>
          </div>

          <div className={"loader-window_preloader"}>
          </div>
          <div className={"loader-window_btn"}>
            <UniversalButton
              type={"button"}
              label={"Cancel & go back"}
              size={"lg"}
              labelColor={"blue"}
              backgroundColor={"none"}
              backgroundHoverColor={"blue-light"}
              onClick={handleCancel}
            />
          </div>
        </div>
    </div>
  );
};

export default LoaderWindow;
